import { Component, OnInit } from "@angular/core";
import { TokenStorageService } from 'src/app/core/service/token-storage.service';
@Component({
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.component.html",
  // styleUrls: "./auth-layout.component.scss",
  styleUrls: ["./auth-layout.component.scss"],
})
export class AuthLayoutComponent implements OnInit {
  constructor(public tokenStorageService: TokenStorageService) {}

  ngOnInit(): void {}
  isLoggedIn(): boolean{
    return !!this.tokenStorageService.getToken();
  }
}
